import { IJobDetail } from 'types/jobs';
import { User } from 'types/user';
import { textlengthLimit } from 'utils/limitTextLength';

import { Typography, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import styles from './JobClientDetails.module.scss';

interface JobClientDetailsProps {
  data: IJobDetail;
  user?: User | null;
  showDetails?: boolean;
}

const JobClientDetails = ({ data, user, showDetails = true }: JobClientDetailsProps) => {
  const theme = useTheme();

  const isAllowedToDisplay = data.displayClientName !== false;
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  if (isMobile || !showDetails) {
    return <></>;
  }

  return (
    <>
      {user && isAllowedToDisplay && (
        <Typography variant="subtitle1" component="h6" className={styles.clientName}>
          {data.accountName}
        </Typography>
      )}
      {user && !isAllowedToDisplay && (
        <Typography variant="subtitle1" component="h6" className={styles.clientName}>
          {data.clientNameMessage || 'Client Name Withheld'}
        </Typography>
      )}
      {data.clientDescriptionPlainText && (
        <div>{textlengthLimit(data?.clientDescriptionPlainText, 300)}</div>
      )}
    </>
  );
};

export default JobClientDetails;
